import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { CreditsContainer, CreditsHeader, CreditsDate, CreditsAmount } from './styles';

const TotalCredits = ({ amount }) => (
  <CreditsContainer>
    <CreditsHeader>Total credit</CreditsHeader>
    <CreditsDate>on {moment().format('MMM DD, YYYY')}</CreditsDate>
    <CreditsAmount>${amount.toFixed(2) || 0.00}</CreditsAmount>
  </CreditsContainer>
);

TotalCredits.propTypes = {
  amount: PropTypes.number.isRequired,
};

export default TotalCredits;
